import { connect } from 'react-redux'
import * as selector from '../../state/task-detail/selector'
import TransitionListWidget from './TransitionListWidget'

const mapStateToProps = (state) => {
    return {
        availableTransitionList: selector.selectAvailableTransitionList(state),
    }
}

export default connect(mapStateToProps)(TransitionListWidget)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/TransitionListWidgetContainer.js